import { createIcon } from '../icon'
import CartAddIcon from '../svg/CartAddIcon'

export const CartAddIconDefault = createIcon(CartAddIcon)
